const employeePhotoRowSize = (isManager: boolean): number => {
  if (window.innerWidth < 425) {
    return 1;
  }
  return isManager ? 2 : 3;
};

export default employeePhotoRowSize;
